import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/primeng';
import { TipoArquivo } from '../../../models/tipoArquivo';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { WebPage } from '../../shared/web-page';
import { CandidatoService } from '../candidato.service';

@Component({
  selector: 'sispac-inserir-arquivo-geral-candidato',
  templateUrl: './inserir-arquivo-geral-candidato.component.html',
  styleUrls: ['./inserir-arquivo-geral-candidato.component.css']
})
export class InserirArquivoGeralCandidatoComponent extends WebPage  implements OnInit {


  form: FormGroup;
  idCandidato;
  tipoArquivo;
  idTipoArquivo:string;
  nomeDocumento;
  uploadUrl: string;

  arquivosToRemove = new FormArray([]);
  tiposAceitos: TipoArquivo[];
  listaTiposAceitos: TipoArquivo[] ;



  numeroVersaoArquivos: any;

  get arquivos() { return this.form.get('arquivos') as FormArray; }
  get IdCandidato() { return this.form.get('idCandidato'); }

  constructor(
    private arquivoService: ArquivoService,
    private fb: FormBuilder,
    private _router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private candidatoService: CandidatoService,
    messageService: MessageService) {

    super(messageService);
      this.route.paramMap.subscribe(params =>
        this.idCandidato = params.get('idCandidato')
      );



      this.form = fb.group({
        descricao:[''],
        arquivos: new FormArray([])
      });

      this.uploadUrl = this.arquivoService.uploadUrl + 'arquivoGeralCandidato' ;
     }

  ngOnInit() {

  }

  downloadArquivo(idArquivo, nomeArquivo) {
    this.arquivoService.downloadArquivo(idArquivo, nomeArquivo);
  }

  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean, idTipoArquivo,nomeTipo) {

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: FormGroup) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);

  }

  submit() {

    if (this.form.value.arquivos.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Arquivo não inserido'
      });
      return;
    }

    if (this.form.value.descricao == '') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'O Campo descrição do arquivo é obrigatório!'
      });
      return;
    }

    const candidatoArquivoGeral = {
      idCandidato: this.idCandidato,
      idArquivo: this.form.value.arquivos[0].idArquivo,
      descricao: this.form.value.descricao
    };


    this.confirmationService.confirm({
      message: 'Deseja enviar o arquivo selecionado?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
          this.candidatoService.inserirArquivoGeral(candidatoArquivoGeral)
          .subscribe(candidato => {
            this.messageService.add({
              severity: 'success',
              summary: 'Atenção',
              detail: 'Arquivo enviado com sucesso'
            });

            this.confirmationService.confirm({
              message: 'Deseja enviar um novo arquivo?',
              header: 'Confirmação',
              icon: 'fa fa-question-circle',
              accept: () => {
                window.location.reload();
              },
              reject:() => {
                this._router.navigate(['/arquivos-gerais',this.idCandidato]);
              }
            });

          });
        }
      });
    }

    cancelar() {
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja cancelar?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.removeArquivosDoBanco(this.arquivos.controls);
          this.removeArquivosDoBanco(this.arquivosToRemove.controls);
          this._router.navigate(['/gerenciar-etapas']);
        }
      });
    }

    removeArquivosDoBanco(arquivos: AbstractControl[]) {
      arquivos.forEach(arquivo =>
        this.arquivoService.removeArquivo(arquivo.value.idArquivo)
          .subscribe(() => {

          })
      );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/candidato/inserir-arquivo-geral-candidato/inserir-arquivo-geral-candidato.component.ts